import React, { Component } from "react";

export class CopyRight extends Component {
  render() {
    return (
      <>
        <section className="copyrightContainer">
          <div className="centerRight">
            <p className="copyRight">
              ©2024 <a href="/">OPG Securities</a>. All rights reserved.
            </p>
          </div>
        </section>
      </>
    );
  }
}

export default CopyRight;
